import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'
import TabsSEO from 'sections/about/parts/TabsSEO'
import { Link } from 'gatsby'

class Pseo extends React.Component {


    shouldComponentUpdate() {
        return false
    }

    render() {
        const Section = styled.section`
          position: relative;
          overflow: hidden;
          background-color: #fff;
          padding-top: 30px;
          @media (max-width: 767px) {
            padding: 80px 20px;
          }
          @media (max-width: 500px) {
            padding: 0 20px;
          }
        `

        const AboutContainer = styled(Container)`
          padding: 50px 0;
          @media (max-width: 500px) {
            padding: 50px 0;
          }
        `

        const Separator = styled.div`
          height: 5px;
          width: 50px;
          background-color: #4285f4;
          margin-bottom: 20px;
        `
        const Heading2 = styled.h2`
          font-size: 60px;
          font-family: Poppins;
          color: #4285f4;
          line-height: 80px;
          text-align: center;
          padding-bottom: 80px;
          font-weight: bold;
        `
        const Heading3 = styled.h3`
          font-size: 40px;
          font-family: Poppins;
          color: #4285f4;
          line-height: 50px;
        `
        const Text = styled.p`
          font-size: 20px;
          font-weight: 300;
          color: #4a4949;
          padding-bottom: 30px;
        `
        const ServiceListElement = styled.li`
          list-style: circle;
          color: #00;
          font-weight: 300;
          font-size: 18px;
          margin: 5px 5px;
          &::before {
            display: inline-block;
            content: "";
            border-radius: 15px;
            height: 15px;
            width: 15px;
            position: relative;
            bottom: 2.5px;
          }
        `
        const ServiceList = styled.ul`
          padding: 0;
          margin: 11px 0 100px 10px;
        `

        const Color1 = styled.span`
          color: #e34133;
        `

        const Color2 = styled.span`
          color: #f3b605;
        `

        const Color3 = styled.span`
          color: #32a350;
        `

        const Element = styled.div`
          margin-bottom: 20px;
          text-align: center;
          img {
            max-height: 500px;
            max-width: 500px;
            width: 100%;
            height: auto;
          }
          transition: 0.2s;
          &:hover {
            transform: translateY(-10px);
          }
          @media (max-width: 767px) {
            width: 100%; /* Ocupar todo el ancho de la pantalla */
            padding: 0;
            margin: 40px 0;
            img {
              max-width: 100%; /* Permitir que la imagen se estire a lo ancho */
              width: 100vw; /* Igual que el viewport */
              height: auto;
              display: block; /* Asegura que no tenga espacio extra por inline */
            }
          }
        `
        const Headinga = styled(Link)`
          color: #78c91c;
          transition: 0.5s;
          font-size: 30px;          
          line-height: 40px;
          &:hover {
            color: #000;
            text-decoration: none;
          }
        `


        return (
            <Section>
                <AboutContainer>
                    <Row>
                        <Col md={12}>

                            <Heading2>¿S<Color1>E</Color1><Color2>O</Color2> qué  <Color3>es</Color3><Color1>?</Color1></Heading2>
                            <Separator />
                            <Text>
                                El SEO, u Optimización para Motores de Búsqueda, es el conjunto de estrategias y técnicas diseñadas para
                                mejorar la visibilidad de un sitio web en los resultados de los motores de búsqueda como Google.
                                ¿La razón? Aumentar la cantidad y calidad del tráfico, llevando tu sitio a la cima.
                            </Text>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>

                            <Heading3>¿Por Qué Necesitas una Agencia SEO en Colombia?</Heading3>
                            <Text>
                                En un mercado competitivo como Colombia, el posicionamiento web es clave para destacar en ciudades como Pereira,
                                Bogotá, Medellín, Cali, Barranquilla y Cartagena. En VASCO Solutions, ofrecemos servicios SEO personalizados que
                                aumentan tu visibilidad en Google, generan más tráfico orgánico y convierten visitantes en clientes. Con más de 8
                                años de experiencia, ayudamos a pymes y grandes empresas a dominar los resultados de búsqueda, tanto a nivel
                                local como nacional.
                            </Text>

                        </Col>
                        <Col md={6}>

                            <Element>
                                <GatsbyImage image={this.props.image1} alt="SEO Pereira" sizes="(max-width: 767px) 300px, 500px" />
                            </Element>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Heading3>Beneficios de nuestros servicios SEO:</Heading3>
                        </Col>
                        <Col md={6}>
                            <ServiceList>
                                <ServiceListElement>
                                    <strong>Aumento de visibilidad:</strong> Aparece en las primeras posiciones de Google para palabras clave relevantes
                                    como "SEO Pereira" o "posicionamiento web Bogotá".
                                </ServiceListElement>
                                <ServiceListElement>
                                    <strong>Tráfico cualificado:</strong> Atrae a clientes potenciales interesados en tus productos o servicios.
                                </ServiceListElement>
                            </ServiceList>
                        </Col>
                        <Col md={6}>
                            <ServiceList>
                                <ServiceListElement>
                                    <strong>Resultados medibles:</strong> Informes detallados para que veas el impacto de tu inversión.
                                </ServiceListElement>
                                <ServiceListElement>
                                    <strong>Enfoque local y nacional:</strong> Optimizamos para búsquedas locales en Pereira y grandes ciudades como
                                    Bogotá, Medellín y Cali, además de mercados internacionales como Miami.
                                </ServiceListElement>
                            </ServiceList>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Heading3>Nuestros Servicios de Posicionamiento Web en Colombia</Heading3>
                            <Text>
                                En VASCO Solutions, ofrecemos una estrategia integral de SEO que combina optimización técnica, contenido de calidad y 
                                construcción de autoridad para garantizar resultados. Nuestros servicios incluyen:
                            </Text>
                            <ServiceList>
                                <ServiceListElement>
                                    Análisis y auditoría SEO integral
                                </ServiceListElement>
                                <ServiceListElement>
                                    Investigación de palabras clave
                                </ServiceListElement>
                                <ServiceListElement>
                                    Optimización On-Page y Off-Page
                                </ServiceListElement>
                                <ServiceListElement>
                                    Creación de contenido persuasivo
                                </ServiceListElement>
                                <ServiceListElement>
                                    Creación de Backlinks
                                </ServiceListElement>
                                <ServiceListElement>
                                    Sin compromisos ni contratos de permanencia
                                </ServiceListElement>
                                <ServiceListElement>
                                    Informe mensual
                                </ServiceListElement>
                            </ServiceList>
                            <Heading3>
                                <Headinga to="/conecta">
                                    ¡Solicita una auditoría SEO gratuita hoy y descubre cómo mejorar tu posicionamiento web en Colombia!
                                </Headinga>
                            </Heading3>
                        </Col>
                        <Col md={6}>
                            <Element>
                                <GatsbyImage image={this.props.image2} alt="SEO Colombia" sizes="(max-width: 767px) 300px, 500px" />
                            </Element>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <TabsSEO />
                        </Col>
                    </Row>
                </AboutContainer>
            </Section>
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "google-partner.jpg" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 500
              )
            }
          }
          image2: file(relativePath: { eq: "seo-pereira.jpg" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 500
              )
            }
          }          
        }
      `}
        render={(data) => {
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            return <Pseo data={data} image1={image1} image2={image2}{...props} />;
        }}
    />
);

export default Iconos;
